<div class="container">
  <app-program-add-cart-button
    class="vertical-center"
    [user]="user"
    [program]="program"
    [minimalView]="true"
  >
  </app-program-add-cart-button>
</div>
